import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import thunk from 'redux-thunk';
import { createBrowserHistory } from 'history';
import rootReducer from '../redux';

import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web and AsyncStorage for react-native
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';

import {axiosBaseURL} from "../config/config";

// Create a history of your choosing (we're using a browser history in this case)
// We setup a basename that we will deploy into IIS as a subdirectory
export const history = createBrowserHistory({basename: axiosBaseURL()});

const initialState = {};
let composeEnhancers = compose;
const middleware = [thunk, routerMiddleware(history)];

if (process.env.NODE_ENV === 'development') {
	composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
}

const composedEnhancers = composeEnhancers(
    applyMiddleware(...middleware)
);

// https://blog.reactnativecoach.com/the-definitive-guide-to-redux-persist-84738167975
const persistConfig = {
    key: 'root',
    storage: storage,
    stateReconciler: autoMergeLevel2, // TODO: Not Working Yet...Merge persisted state with new state values not yet in local storage
    whitelist: ['persist'],
};

const pReducer = persistReducer(persistConfig, rootReducer(history));

export const store = createStore(pReducer, initialState, composedEnhancers);

export const persistor = persistStore(store);

export default store;
